var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.825 1.5C3.07 1.5 0 4.533 0 8.269c0 7.661 8.693 11.674 11.625 14.1l.375.319.375-.32C15.307 19.944 24 15.93 24 8.269 24 4.534 20.93 1.5 17.175 1.5c-2.086 0-3.923.968-5.175 2.438C10.748 2.468 8.91 1.5 6.825 1.5Z"
  })));
};
export { SvgHeartFilled as ReactComponent };